import "../nav/nav.css";
import { NavLink, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axios from "axios";
import { baseURL } from "../../../constants/url";

function Nav() {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [openCategory, setOpenCategory] = useState(null); // track open category dropdown
  const [isMenuOpen, setIsMenuOpen] = useState(false); // track mobile menu open/close

  // Close dropdown when route changes
  useEffect(() => {
    setOpenCategory(null);
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${baseURL}common/product_categories/`);
        setCategories(res.data || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  // Fetch subcategories
  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const res = await axios.get(`${baseURL}common/subcategories/`);
        setSubCategories(res.data || []);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubCategories();
  }, []);

  // Helper: filter subcategories by category
  const getSubCategoriesByCat = (catId) => {
    return subCategories.filter((sub) => sub.category === catId);
  };

  return (
    <>
      <div className="navbar_custom">
        <nav className="navbar navbar-expand-lg nav_dec mt_5 pl_30 pr_30 bg_white_g">
          <div className="container-fluid">
              {/* Hamburger Menu Button (Mobile) */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Collapsible Menu */}
            <div
              className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                {/* Categories in Navbar */}
                {categories.map((cat) => (
                  <li
                    key={cat.id}
                    className="nav-item dropdown"
                    onMouseEnter={() =>
                      window.innerWidth > 768 && setOpenCategory(cat.id)
                    }
                    onMouseLeave={() =>
                      window.innerWidth > 768 && setOpenCategory(null)
                    }
                  >
                    <NavLink
                      className="nav-link dropdown-toggle d-flex align-center gap-2"
                      to="#"
                      onClick={(e) => {
                        if (window.innerWidth <= 768) {
                          e.preventDefault();
                          setOpenCategory(
                            openCategory === cat.id ? null : cat.id
                          );
                        }
                      }}
                    >
                      {cat.name}
                      <KeyboardArrowDownIcon fontSize="small" />
                    </NavLink>

                    {/* Dropdown Subcategories */}
                    {openCategory === cat.id && (
                      <ClickAwayListener
                        onClickAway={() =>
                          window.innerWidth > 768 && setOpenCategory(null)
                        }
                      >
                        <ul className="dropdown-menu show dropdown-menu-custom">
                          {getSubCategoriesByCat(cat.id).length > 0 ? (
                            getSubCategoriesByCat(cat.id).map((sub) => (
                              <li key={sub.id} className="grid_formate">
                                <NavLink
                                  className="dropdown-item"
                                  to={`/subcategoriesproducts/${sub.id}`}
                                >
                                  {sub.name}
                                </NavLink>
                              </li>
                            ))
                          ) : (
                            <li>
                              <span className="dropdown-item">
                                No subcategories
                              </span>
                            </li>
                          )}
                        </ul>
                      </ClickAwayListener>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Nav;
